import { Utils } from '@genial/utils';

import { mountAccount } from '../../../../store/customer/normalize';
import { CustomerSectionItemsProps, DeviceType, messageError } from '../../utils';
import { SuitabilityProfile } from '../SuitabilityProfile';

import { CustomerSectionProps } from '.';

export const createSectionCustomerItems = ({
  device,
  ...props
}: CustomerSectionProps & DeviceType) => {
  const { cpfCnpjFormatted, suitabilityProfileName, availableBalance, fullCustomerItem } = props;
  const documentFormatted = cpfCnpjFormatted
    ? Utils.Mask.CpfOrCnpj(cpfCnpjFormatted)
    : messageError;

  const suitabilityNameComponent = suitabilityProfileName ? (
    <SuitabilityProfile value={suitabilityProfileName} />
  ) : (
    messageError
  );

  const suitabilityProfileNameValue = suitabilityProfileName || messageError;
  const suitabilityName =
    device === 'mobile' ? suitabilityProfileNameValue : suitabilityNameComponent;

  const balance =
    availableBalance || availableBalance === 0 ? Utils.Mask.Money(availableBalance) : messageError;

  const custodyAccount = mountAccount(
    fullCustomerItem?.pnpAccountNumber || 0,
    fullCustomerItem?.pnpAccountDigit
  );

  const data = { documentFormatted, suitabilityName, balance, custodyAccount, ...props };

  switch (device) {
    case 'desktop':
      return createSectionCustomerDefaultItems(data);
    case 'tablet':
      return createSectionCustomerTabletItems(data);
    case 'mobile':
      return createSectionCustomerDefaultItems(data);
    default:
      return [];
  }
};

const createSectionCustomerTabletItems = ({
  balance,
  documentFormatted,
  suitabilityName,
  name,
  registrationStatusName,
}: CustomerSectionItemsProps) => {
  return [
    { testID: 'suitability-profile-name', value: suitabilityName },
    { testID: 'name', label: 'Nome', value: name || messageError },
    { testID: 'cpf-cnpj-formatted', label: 'CPF/CNPJ', value: documentFormatted },
    {
      testID: 'registration-status-name',
      label: 'Cadastro',
      value: registrationStatusName || messageError,
    },
    { testID: 'available-balance', label: 'Saldo disponível', value: balance },
  ];
};
const createSectionCustomerDefaultItems = ({
  balance,
  documentFormatted,
  suitabilityName,
  name,
  registrationStatusName,
  custodyAccount,
}: CustomerSectionItemsProps) => {
  return [
    { testID: 'name', label: 'Nome', value: name || messageError },
    { testID: 'cpf-cnpj-formatted', label: 'CPF/CNPJ', value: documentFormatted },
    {
      testID: 'custody-account',
      label: 'Conta de Custódia',
      value: custodyAccount || messageError,
    },
    { testID: 'suitability-profile-name', label: 'Suitability', value: suitabilityName },
    {
      testID: 'registration-status-name',
      label: 'Situação cadastral',
      value: registrationStatusName || messageError,
    },
    { testID: 'available-balance', label: 'Saldo disponível', value: balance },
  ];
};
